import { render, staticRenderFns } from "./multiChangeStatus.vue?vue&type=template&id=6c3b161c&scoped=true&"
import script from "./multiChangeStatus.vue?vue&type=script&lang=js&"
export * from "./multiChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./multiChangeStatus.vue?vue&type=style&index=0&id=6c3b161c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b161c",
  null
  
)

export default component.exports